import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import router from './router'
import './plugins/element.js'
import axios from 'axios'
import './plugins/vant.js'
import './assets/style/index.css'
import '@/assets/font/font.css'
import { queryURLParams, downloadFile, checkPlatform, getOffsetTop, gdjz, clientHeight, scrollIntoView } from "@/plugins/meth";

Vue.prototype.queryURLParams = queryURLParams
Vue.prototype.downloadFile = downloadFile
Vue.prototype.checkPlatform = checkPlatform
Vue.prototype.getOffsetTop = getOffsetTop
Vue.prototype.gdjz = gdjz
Vue.prototype.clientHeight = clientHeight
Vue.prototype.scrollIntoView = scrollIntoView

import animated from 'animate.css'
Vue.use(animated)

import contentTitle from "@/components/contentTitle.vue";
// 注册为全局组件
Vue.component('contentTitle', contentTitle)



Vue.prototype.downloadUrl = 'https://senior.hz-college.com/learn/senior/exam/pages/downLoad/file?fileId=' //下载单个文件链接
Vue.prototype.downAllUrl = 'https://senior.hz-college.com/learn/senior/exam/pages/downLoad/page?pageId=' //下载全部文件链接

Vue.config.productionTip = false

// 2019.10.31 之前写的下面三行代码，想要配置反向代理，但是不行。现在看来应该写在request文件夹下的http.js文件里，
// axios.defaults.baseURL = '/api'; 
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
Vue.prototype.$http = axios


router.afterEach((to, from, next) => {

  window.scrollTo(0, 0);

})

router.beforeEach((to, from, next) => {
  //判断不是这几个页面就跳转移动端页面
  let name = to.name
  if (name == 'InfoDetails' || name == 'previewPdf' || name == 'previewImg') {
    if (to.meta.title) { //拦截后设置标题
      document.title = to.meta.title
    }
    next()
    return
  } else {
    var sUserAgent = navigator.userAgent.toLowerCase();
    if (/ipad|iphone|midp|rv:1.2.3.4|ucweb|android|windows ce|windows mobile/.test(sUserAgent)) {
      //跳转移动端页面
      window.location.href = "https://www.hnhongzhiedu.com/mobile";
    }
  }

  if (to.meta.title) { //拦截后设置标题
    document.title = to.meta.title
  }
  next()
})

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
